export var SettlementState;
(function (SettlementState) {
    SettlementState["CANCELED"] = "CANCELED";
    SettlementState["CONFIRMED"] = "CONFIRMED";
    SettlementState["PENDING_DEPOSIT"] = "PENDING_DEPOSIT";
    SettlementState["PENDING_WITHDRAWAL"] = "PENDING_WITHDRAWAL";
})(SettlementState || (SettlementState = {}));
